<template>
    <div class="product_link_variant arrow-source" :id="item.id" @dragstart="$emit('dragstart', $event)" :data-index="dataIndex">
        <div class="left">
            <div class="img_wrpr">
                <img class="placeholder-img" :src="require('@/assets/img/placeholder-img.svg')">
            </div>
            <h3 class="item_title">{{item.title}}</h3>
        </div>
        <a @click="$emit('unlinkMe', item.id)" class="btn brdr_btn link_item_btn unlink_btn" v-if="!allowedToLink">
            <inline-svg :src="require('@/assets/img/unlink_item_icon.svg')"/> Unlink
        </a>
    </div>
</template>

<script>

export default {
    components: {

    },
    props: ['item', 'dataIndex', 'allowedToLink' ],
}
</script>
